import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Home from '../views/coachAssessmentDetail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    },
    {
        path: '/app_voice',
        name: 'app_voice',
        component: () => import(/* webpackChunkName: "about" */ '../views/app_voice.vue'),
    },
    {
        path: '/teamList',
        name: 'teamList',
        meta: {
            keepAlive: false, // 不需要被缓存,
            promptMsg:' 梯队的名称， 比如 小京，一线队',//页脚提示信息
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/teamList.vue'),
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        children: [
            {
                path: '/about/main_btn',
                name: 'main_btn',
                meta: {
                    keepAlive: false, // 不需要被缓存,
                    promptMsg:' 报告的名称， 比如 小京，球队报告，或者小京，AC报告',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/MainBtn.vue'),
            },
            {
                path: '/about/introduce',
                name: 'introduce',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'这是俱乐部介绍',
                    promptMsg:'精彩瞬间 或者 小京，视频资料',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/introduce.vue'),
            },
            {
                path: '/about/moment',
                name: 'moment',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'这是俱乐部精彩瞬间',
                    promptMsg:'返回 或者 小京，回到首页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/moment.vue'),
            },
            {
                path: '/about/assessmentReport',
                name: 'assessmentReport',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'的评估报告',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/assessmentReport.vue'),
            },
            {
                path: '/about/assessmentReportDetail/:id/:seasonId',
                name: 'assessmentReportDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/assessmentReportDetail.vue'),
            },


            {
                path: '/about/teamReport',
                name: 'teamReport',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的概况',
                    promptMsg:'查看赛程，伤病报告，或者训练计划',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/teamReport.vue'),
            },
            {
                path: '/about/injuryReport',
                name: 'injuryReport',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的伤病概况',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/injuryReport.vue'),
            },
            {
                path: '/about/trainingReport',
                name: 'trainingReport',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的训练计划',
                    promptMsg:'查看球队阵容，或者赛程',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/trainingReport.vue'),
            },
            {
                path: '/about/lineup',
                name: 'lineup',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的阵容',
                    promptMsg:'查看教练员列表，或者查看球员列表',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/lineup.vue'),
            },
            {
                path: '/about/schedule',
                name: 'schedule',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的赛程',
                    promptMsg:'查看球员评估报告，或者 查看运动表现',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/schedule.vue'),
            },
            {
                path: '/about/athleticPerformance',
                name: 'athleticPerformance',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的运动表现情况',
                    promptMsg:'查看 AC 报告',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/athleticPerformance.vue'),
            },
            {
                path: '/about/videoList',
                name: 'videoList',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的视频列表',
                    promptMsg:'”1号视频“，”2号视频”， 或者 小京，回到首页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/videoList.vue'),
            },
            {
                path: '/about/videoClipList',
                name: 'videoClipList',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的精彩视频片段列表',
                    promptMsg:'”1号视频“，”2号视频”， 或者 小京，返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/videoClipList.vue'),
            },
            {
                path: '/about/lessonPlan',
                name: 'lessonPlan',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'这是俱乐部的训练教案',
                    promptMsg:'”1号教案“，”2号教案“ 或者 小京，“热身”，“核心一”。如果您想看下一页的教案，可以说：小京，下一页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/lessonPlan.vue'),
            },
            {
                path: '/about/lessonDetail',
                name: 'lessonDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'训练视频 或者 小京，返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/lessonDetail.vue'),
            },
            {
                path: '/about/injuryDetail/:id/:injuryImg/:number',
                name: 'injuryDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/injuryDetail.vue'),
            },
            {
                path: '/about/playersReport',
                name: 'playersReport',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'的球员列表',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/playersReport.vue'),
            },
            {
                path: '/about/playersDetail/:id',
                name: 'playersDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/playersDetail.vue'),
            },
            {
                path: '/about/coachList',
                name: 'coachList',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的教练员列表',
                    promptMsg:'1号教练员，2号教练员 或者 教练员的名字',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachList.vue'),
            },
            {
                path: '/about/coachDetail/:id',
                name: 'coachDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachDetail.vue'),
            },
            {
                path: '/about/coachAssessment',
                name: 'coachAssessment',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的教练员评估列表',
                    promptMsg:'1号教练员，2号教练员 或者 教练员的名字 或者 训练计划',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachAssessment.vue'),
            },
            {
                path: '/about/coachAssessmentDetail/:id',
                name: 'coachAssessmentDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachAssessmentDetail.vue'),
            },
            {
                path: '/about/AC_report',
                name: 'AC_report',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的概况',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/AC_report.vue'),
            },
            {
                path: '/about/AC_reportDetail/:id/:name',
                name: 'AC_reportDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/AC_reportDetail.vue'),
            },
            {
                path: '/about/bodyBtn',
                name: 'bodyBtn',
                meta: {
                    speakStr:'这是体测报告详细报表',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'某项报告名称，比如 speed报告',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/bodyBtn.vue'),
            },
            {
                path: '/about/intensityReport',
                name: 'intensityReport',
                meta: {
                    speakStr:'的强度报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/intensityReport.vue'),
            },
            {
                path: '/about/intensityReportDetail/:id/:name',
                name: 'intensityReportDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/intensityReportDetail.vue'),
            },
            {
                path: '/about/AC_AIM',
                name: 'AC_AIM',
                meta: {
                    speakStr:'的AC目标报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/AC_AIM.vue'),
            },
            {
                path: '/about/AC_AIM_Detail/:id/:name',
                name: 'AC_AIM_Detail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/AC_AIM_Detail.vue'),
            },
            {
                path: '/about/bodyAPHV',
                name: 'bodyAPHV',
                meta: {
                    speakStr:'的aphv报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'返回 或者 回到梯队',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/bodyAPHV.vue'),
            },
            {
                path: '/about/bodySpeed',
                name: 'bodySpeed',
                meta: {
                    speakStr:'的速度报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'返回 或者 回到梯队',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/bodySpeed.vue'),
            },
            {
                path: '/about/bodyBasis',
                name: 'bodyBasis',
                meta: {
                    speakStr:'的基础报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'返回 或者 回到梯队',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/bodyBasis.vue'),
            },
            {
                path: '/about/bodyEndurance',
                name: 'bodyEndurance',
                meta: {
                    speakStr:'的耐力测试报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'返回 或者 回到梯队',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/bodyEndurance.vue'),
            },
            {
                path: '/about/bodyAgility',
                name: 'bodyAgility',
                meta: {
                    speakStr:'的敏捷度报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'返回 或者 回到梯队',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/bodyAgility.vue'),
            },
            {
                path: '/about/lineup',
                name: 'lineup',
                meta: {
                    speakStr:'的阵容',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'返回 或者 回到梯队',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/lineup.vue'),
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
